import React from 'react'

const ModuleDisplayPhone = ({ value }) => {
    return (
        <a href={`tel:${value}`}> {value} </a>
    )
}

export default ModuleDisplayPhone